import {UiData} from "src/types/type";

export const defaultUiStyle: UiData = {
  layoutsInsert: {
    mainBg: '#fff',
    certs: {
      type: '',
      borderColor: '#fff',
      backgroundColor: '#fff',
    },
    agency: {
      shape: '',
      actColor: '#FF2942',
    },
  },
  layoutsConfirm: {
    confirmHover: false,
    submitBtn: {
      borderRadius: '5px',
      fontSize: '13.5px',
      letterSpacing: '-1px',
      backgroundColor: '#1e34de',
      fontColor: '#fff',
      fontWeight: 400,
    },
  },
  layoutsFooter: {
    color: 'black',
    backgroundColor: '#fff',
  },
  layoutsTerms: {
    direction: '',
    shape: 'line',
    actColor: '#fff',
    borderRadius: 'none',
  },
  layoutsVerify: {
    verifyDir: '',
    cashSpace: '-1.5px',
    verifyBtn: {
      borderRadius: '5px',
      fontSize: '13.5px',
      letterSpacing: '-1px',
      backgroundColor: '#1e34de',
      fontColor: '#ffffff',
      fontWeight: 400,
    },
    cancelBtn: {
      borderRadius: 'none',
      fontSize: '13.5px',
      letterSpacing: '-1px',
      backgroundColor: '#fff',
      fontColor: '#d8d8d8',
      fontWeight: 400,
    },
  },
};